let loaded = false;

export function openCalendly(url) {
  if (loaded) {
    window.Calendly?.initPopupWidget({ url });
    return;
  }

  const css = document.createElement('link');
  css.rel  = 'stylesheet';
  css.href = 'https://assets.calendly.com/assets/external/widget.css';
  document.head.appendChild(css);

  const script  = document.createElement('script');
  script.src    = 'https://assets.calendly.com/assets/external/widget.js';
  script.async  = true;
  script.onload = () => {
    loaded = true;
    window.Calendly?.initPopupWidget({ url });
  };
  document.head.appendChild(script);
}
